var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlaskVial = function SvgFlaskVial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flask-vial_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 5v19.444l-1 1.443V15h-10v11a5 5 0 0 0 7 4.581v1.075A6.002 6.002 0 0 1 2.5 26V5h-2V4h16v1zm-11 9h10V5h-10zm19 4v.156l-.087.131L18.456 24H34.55l-3.956-5.713-.088-.13V5H22.5zm-4.738 7L13.5 31.156V35h26v-3.844L35.237 25zM31.5 5v12.844l8.913 12.868.087.132V36h-28v-5.156l.088-.132L21.5 17.844V5h-2V4h14v1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flask-vial_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })))));
};
export default SvgFlaskVial;